import { styled } from '@mui/material/styles'
import React from 'react'

export interface IOwnProps {
  className?: string
}

export type IProps = IOwnProps

//import messages from './MainContent.messages'

const MainContent:React.FC<IProps> = (props) => {
  const {
    children,
    className,
  } = props

  return (
    <main className={className}>
      {children}
    </main>
  )
}

export default styled(MainContent)({
  flexGrow: 1,
  display: 'grid',
})
